import { g as getDefaultExportFromCjs, c as commonjsGlobal } from "./_commonjsHelpers-0c53d963.js";
const PAGEVIEW = {
  eventName: "PageView",
  type: "Page"
}, CLICK = {
  eventName: "Click"
}, IMPRESSION = {
  eventName: "Impression"
}, SUBMIT = {
  eventName: "Submit"
}, SEARCH = {
  eventName: "Search"
}, PURCHASE = {
  eventName: "Purchase"
}, FOCUS = {
  eventName: "Focus"
}, CHANGE = {
  eventName: "Change"
}, EventProperties = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CHANGE,
  CLICK,
  FOCUS,
  IMPRESSION,
  PAGEVIEW,
  PURCHASE,
  SEARCH,
  SUBMIT
}, Symbol.toStringTag, { value: "Module" }));
var rngBrowser = { exports: {} }, getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
  var rnds8 = new Uint8Array(16);
  rngBrowser.exports = function() {
    return getRandomValues(rnds8), rnds8;
  };
} else {
  var rnds = new Array(16);
  rngBrowser.exports = function() {
    for (var i = 0, r; i < 16; i++)
      i & 3 || (r = Math.random() * 4294967296), rnds[i] = r >>> ((i & 3) << 3) & 255;
    return rnds;
  };
}
var rngBrowserExports = rngBrowser.exports, byteToHex = [];
for (var i = 0; i < 256; ++i)
  byteToHex[i] = (i + 256).toString(16).substr(1);
function bytesToUuid(buf, offset) {
  var i = offset || 0, bth = byteToHex;
  return [
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    "-",
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]],
    bth[buf[i++]]
  ].join("");
}
var bytesToUuid_1 = bytesToUuid, browserCookies$1 = {};
(function(exports) {
  exports.defaults = {}, exports.set = function(name2, value, options) {
    var opts = options || {}, defaults2 = exports.defaults, expires = opts.expires || defaults2.expires, domain = opts.domain || defaults2.domain, path = opts.path !== void 0 ? opts.path : defaults2.path !== void 0 ? defaults2.path : "/", secure = opts.secure !== void 0 ? opts.secure : defaults2.secure, httponly = opts.httponly !== void 0 ? opts.httponly : defaults2.httponly, samesite = opts.samesite !== void 0 ? opts.samesite : defaults2.samesite, expDate = expires ? new Date(
      // in case expires is an integer, it should specify the number of days till the cookie expires
      typeof expires == "number" ? (/* @__PURE__ */ new Date()).getTime() + expires * 864e5 : (
        // else expires should be either a Date object or in a format recognized by Date.parse()
        expires
      )
    ) : 0;
    document.cookie = name2.replace(/[^+#$&^`|]/g, encodeURIComponent).replace("(", "%28").replace(")", "%29") + "=" + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) + // Encode cookie value (RFC6265)
    (expDate && expDate.getTime() >= 0 ? ";expires=" + expDate.toUTCString() : "") + // Add expiration date
    (domain ? ";domain=" + domain : "") + // Add domain
    (path ? ";path=" + path : "") + // Add path
    (secure ? ";secure" : "") + // Add secure option
    (httponly ? ";httponly" : "") + // Add httponly option
    (samesite ? ";samesite=" + samesite : "");
  }, exports.get = function(name2) {
    for (var cookies2 = document.cookie.split(";"); cookies2.length; ) {
      var cookie = cookies2.pop(), separatorIndex = cookie.indexOf("=");
      separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
      var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ""));
      if (cookie_name === name2)
        return decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
    return null;
  }, exports.erase = function(name2, options) {
    exports.set(
      name2,
      "",
      {
        expires: -1,
        domain: options && options.domain,
        path: options && options.path,
        secure: 0,
        httponly: 0
      }
    );
  }, exports.all = function() {
    for (var all2 = {}, cookies2 = document.cookie.split(";"); cookies2.length; ) {
      var cookie = cookies2.pop(), separatorIndex = cookie.indexOf("=");
      separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
      var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ""));
      all2[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
    return all2;
  };
})(browserCookies$1);
const browserCookies = /* @__PURE__ */ getDefaultExportFromCjs(browserCookies$1);
function arrayMap$1(array, iteratee) {
  for (var index = -1, length = array == null ? 0 : array.length, result = Array(length); ++index < length; )
    result[index] = iteratee(array[index], index, array);
  return result;
}
var _arrayMap = arrayMap$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2, eq$1 = eq_1;
function assocIndexOf$4(array, key) {
  for (var length = array.length; length--; )
    if (eq$1(array[length][0], key))
      return length;
  return -1;
}
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index = assocIndexOf$3(data, key);
  if (index < 0)
    return !1;
  var lastIndex = data.length - 1;
  return index == lastIndex ? data.pop() : splice.call(data, index, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index = assocIndexOf$2(data, key);
  return index < 0 ? void 0 : data[index][1];
}
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? (++this.size, data.push([key, value])) : data[index][1] = value, this;
}
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index < length; ) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3(), this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data.delete(key);
  return this.size = data.size, result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$8 = freeGlobal || freeSelf || Function("return this")(), _root = root$8, root$7 = _root, Symbol$5 = root$7.Symbol, _Symbol = Symbol$5, Symbol$4 = _Symbol, objectProto$5 = Object.prototype, hasOwnProperty$4 = objectProto$5.hasOwnProperty, nativeObjectToString$1 = objectProto$5.toString, symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = !0;
  } catch {
  }
  var result = nativeObjectToString$1.call(value);
  return unmasked && (isOwn ? value[symToStringTag$1] = tag : delete value[symToStringTag$1]), result;
}
var _getRawTag = getRawTag$1, objectProto$4 = Object.prototype, nativeObjectToString = objectProto$4.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1, Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$5(value) {
  return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$5;
function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$3, baseGetTag$4 = _baseGetTag, isObject$2 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$2(value))
    return !1;
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2, root$6 = _root, coreJsData$1 = root$6["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1, funcProto$1 = Function.prototype, funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch {
    }
    try {
      return func + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$2, isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$1 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto = Function.prototype, objectProto$3 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$3 = objectProto$3.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$3).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$1(value) || isMasked(value))
    return !1;
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7, getNative$6 = _getNative, root$5 = _root, Map$3 = getNative$6(root$5, "Map"), _Map = Map$3, getNative$5 = _getNative, nativeCreate$4 = getNative$5(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  return this.size -= result ? 1 : 0, result;
}
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$1 = Object.prototype, hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$1.call(data, key);
}
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  return this.size += this.has(key) ? 0 : 1, data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value, this;
}
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index < length; ) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1, Hash = _Hash, ListCache$2 = _ListCache, Map$2 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache$2)(),
    string: new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key).delete(key);
  return this.size -= result ? 1 : 0, result;
}
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  return data.set(key, value), this.size += data.size == size ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  for (this.clear(); ++index < length; ) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, ListCache$1 = _ListCache, Map$1 = _Map, MapCache$2 = _MapCache, LARGE_ARRAY_SIZE = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1)
      return pairs.push([key, value]), this.size = ++data.size, this;
    data = this.__data__ = new MapCache$2(pairs);
  }
  return data.set(key, value), this.size = data.size, this;
}
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype.delete = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var _Stack = Stack, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  return this.__data__.set(value, HASH_UNDEFINED), this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1, MapCache$1 = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(values) {
  var index = -1, length = values == null ? 0 : values.length;
  for (this.__data__ = new MapCache$1(); ++index < length; )
    this.add(values[index]);
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(array, predicate) {
  for (var index = -1, length = array == null ? 0 : array.length; ++index < length; )
    if (predicate(array[index], index, array))
      return !0;
  return !1;
}
var _arraySome = arraySome$1;
function cacheHas$1(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$1, SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays$1(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength))
    return !1;
  var arrStacked = stack.get(array), othStacked = stack.get(other);
  if (arrStacked && othStacked)
    return arrStacked == other && othStacked == array;
  var index = -1, result = !0, seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  for (stack.set(array, other), stack.set(other, array); ++index < arrLength; ) {
    var arrValue = array[index], othValue = other[index];
    if (customizer)
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    if (compared !== void 0) {
      if (compared)
        continue;
      result = !1;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack)))
          return seen.push(othIndex);
      })) {
        result = !1;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = !1;
      break;
    }
  }
  return stack.delete(array), stack.delete(other), result;
}
var _equalArrays = equalArrays$1, root$4 = _root, Uint8Array$2 = root$4.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(map) {
  var index = -1, result = Array(map.size);
  return map.forEach(function(value, key) {
    result[++index] = [key, value];
  }), result;
}
var _mapToArray = mapToArray$1;
function setToArray$1(set) {
  var index = -1, result = Array(set.size);
  return set.forEach(function(value) {
    result[++index] = value;
  }), result;
}
var _setToArray = setToArray$1, Symbol$2 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2, boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset)
        return !1;
      object = object.buffer, other = other.buffer;
    case arrayBufferTag$1:
      return !(object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other)));
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object, +other);
    case errorTag$1:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object == other + "";
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      if (convert || (convert = setToArray), object.size != other.size && !isPartial)
        return !1;
      var stacked = stack.get(object);
      if (stacked)
        return stacked == other;
      bitmask |= COMPARE_UNORDERED_FLAG, stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      return stack.delete(object), result;
    case symbolTag$1:
      if (symbolValueOf)
        return symbolValueOf.call(object) == symbolValueOf.call(other);
  }
  return !1;
}
var _equalByTag = equalByTag, isArray$2 = Array.isArray, isArray_1 = isArray$2;
const isArray$3 = /* @__PURE__ */ getDefaultExportFromCjs(isArray_1);
function isObjectLike$4(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$4, baseGetTag$3 = _baseGetTag, isObjectLike$3 = isObjectLike_1, argsTag$1 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$3(value) && baseGetTag$3(value) == argsTag$1;
}
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$2 = isObjectLike_1, objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty, propertyIsEnumerable = objectProto.propertyIsEnumerable, isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$2(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
}, isArguments_1 = isArguments, isBuffer$1 = { exports: {} };
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse;
isBuffer$1.exports;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1, freeExports = exports && !exports.nodeType && exports, freeModule = freeExports && !0 && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, Buffer = moduleExports ? root2.Buffer : void 0, nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$1, isBuffer$1.exports);
var isBufferExports = isBuffer$1.exports, MAX_SAFE_INTEGER = 9007199254740991;
function isLength$1(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$1, baseGetTag$2 = _baseGetTag, isLength = isLength_1, isObjectLike$1 = isObjectLike_1, argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$1 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength(value.length) && !!typedArrayTags[baseGetTag$2(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1, _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module, exports) {
  var freeGlobal2 = _freeGlobal, freeExports = exports && !exports.nodeType && exports, freeModule = freeExports && !0 && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, freeProcess = moduleExports && freeGlobal2.process, nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      return types || freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports, baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray, getNative$4 = _getNative, root$3 = _root, DataView$1 = getNative$4(root$3, "DataView"), _DataView = DataView$1, getNative$3 = _getNative, root$2 = _root, Promise$2 = getNative$3(root$2, "Promise"), _Promise = Promise$2, getNative$2 = _getNative, root$1 = _root, Set$1 = getNative$2(root$1, "Set"), _Set = Set$1, getNative$1 = _getNative, root = _root, WeakMap$1 = getNative$1(root, "WeakMap"), _WeakMap = WeakMap$1, DataView = _DataView, Map = _Map, Promise$1 = _Promise, Set = _Set, WeakMap = _WeakMap, baseGetTag$1 = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap), getTag = baseGetTag$1;
(DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) && (getTag = function(value) {
  var result = baseGetTag$1(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
  if (ctorString)
    switch (ctorString) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return result;
});
var _getTag = getTag, baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1, symbolTag = "[object Symbol]";
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$1, MapCache = _MapCache, FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key))
      return cache.get(key);
    var result = func.apply(this, args);
    return memoized.cache = cache.set(key, result) || cache, result;
  };
  return memoized.cache = new (memoize$1.Cache || MapCache)(), memoized;
}
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1, memoize = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    return cache.size === MAX_MEMOIZE_SIZE && cache.clear(), key;
  }), cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = memoizeCapped(function(string) {
  var result = [];
  return string.charCodeAt(0) === 46 && result.push(""), string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  }), result;
}), _stringToPath = stringToPath, Symbol$1 = _Symbol, arrayMap = _arrayMap, isArray$1 = isArray_1, isSymbol = isSymbol_1, INFINITY = 1 / 0, symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value) {
  if (typeof value == "string")
    return value;
  if (isArray$1(value))
    return arrayMap(value, baseToString) + "";
  if (isSymbol(value))
    return symbolToString ? symbolToString.call(value) : "";
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
var _baseToString = baseToString, getNative = _getNative, defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    return func({}, "", {}), func;
  } catch {
  }
}(), _defineProperty = defineProperty, axios$1 = { exports: {} }, bind$2 = function(fn, thisArg) {
  return function() {
    for (var args = new Array(arguments.length), i = 0; i < args.length; i++)
      args[i] = arguments[i];
    return fn.apply(thisArg, args);
  };
}, bind$1 = bind$2, toString = Object.prototype.toString;
function isArray(val) {
  return toString.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val > "u";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer == "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData < "u" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? result = ArrayBuffer.isView(val) : result = val && val.buffer && val.buffer instanceof ArrayBuffer, result;
}
function isString(val) {
  return typeof val == "string";
}
function isNumber(val) {
  return typeof val == "number";
}
function isObject(val) {
  return val !== null && typeof val == "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]")
    return !1;
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams < "u" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach(obj, fn) {
  if (!(obj === null || typeof obj > "u"))
    if (typeof obj != "object" && (obj = [obj]), isArray(obj))
      for (var i = 0, l = obj.length; i < l; i++)
        fn.call(null, obj[i], i, obj);
    else
      for (var key in obj)
        Object.prototype.hasOwnProperty.call(obj, key) && fn.call(null, obj[key], key, obj);
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    isPlainObject(result[key]) && isPlainObject(val) ? result[key] = merge(result[key], val) : isPlainObject(val) ? result[key] = merge({}, val) : isArray(val) ? result[key] = val.slice() : result[key] = val;
  }
  for (var i = 0, l = arguments.length; i < l; i++)
    forEach(arguments[i], assignValue);
  return result;
}
function extend(a, b, thisArg) {
  return forEach(b, function(val, key) {
    thisArg && typeof val == "function" ? a[key] = bind$1(val, thisArg) : a[key] = val;
  }), a;
}
function stripBOM(content) {
  return content.charCodeAt(0) === 65279 && (content = content.slice(1)), content;
}
var utils$9 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
}, utils$8 = utils$9;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function(url, params, paramsSerializer) {
  if (!params)
    return url;
  var serializedParams;
  if (paramsSerializer)
    serializedParams = paramsSerializer(params);
  else if (utils$8.isURLSearchParams(params))
    serializedParams = params.toString();
  else {
    var parts = [];
    utils$8.forEach(params, function(val, key) {
      val === null || typeof val > "u" || (utils$8.isArray(val) ? key = key + "[]" : val = [val], utils$8.forEach(val, function(v) {
        utils$8.isDate(v) ? v = v.toISOString() : utils$8.isObject(v) && (v = JSON.stringify(v)), parts.push(encode(key) + "=" + encode(v));
      }));
    }), serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    hashmarkIndex !== -1 && (url = url.slice(0, hashmarkIndex)), url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}, utils$7 = utils$9;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function(fulfilled, rejected, options) {
  return this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : !1,
    runWhen: options ? options.runWhen : null
  }), this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function(id) {
  this.handlers[id] && (this.handlers[id] = null);
};
InterceptorManager$1.prototype.forEach = function(fn) {
  utils$7.forEach(this.handlers, function(h) {
    h !== null && fn(h);
  });
};
var InterceptorManager_1 = InterceptorManager$1, utils$6 = utils$9, normalizeHeaderName$1 = function(headers, normalizedName) {
  utils$6.forEach(headers, function(value, name2) {
    name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase() && (headers[normalizedName] = value, delete headers[name2]);
  });
}, enhanceError$1 = function(error, config, code, request2, response) {
  return error.config = config, code && (error.code = code), error.request = request2, error.response = response, error.isAxiosError = !0, error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, error;
}, createError, hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var enhanceError3 = enhanceError$1;
  return createError = function(message, config, code, request2, response) {
    var error = new Error(message);
    return enhanceError3(error, config, code, request2, response);
  }, createError;
}
var settle, hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var createError2 = requireCreateError();
  return settle = function(resolve, reject, response) {
    var validateStatus2 = response.config.validateStatus;
    !response.status || !validateStatus2 || validateStatus2(response.status) ? resolve(response) : reject(createError2(
      "Request failed with status code " + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }, settle;
}
var cookies, hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var utils2 = utils$9;
  return cookies = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(name2, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name2 + "=" + encodeURIComponent(value)), utils2.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString()), utils2.isString(path) && cookie.push("path=" + path), utils2.isString(domain) && cookie.push("domain=" + domain), secure === !0 && cookie.push("secure"), document.cookie = cookie.join("; ");
        },
        read: function(name2) {
          var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function(name2) {
          this.write(name2, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies;
}
var isAbsoluteURL, hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  return hasRequiredIsAbsoluteURL || (hasRequiredIsAbsoluteURL = 1, isAbsoluteURL = function(url) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
  }), isAbsoluteURL;
}
var combineURLs, hasRequiredCombineURLs;
function requireCombineURLs() {
  return hasRequiredCombineURLs || (hasRequiredCombineURLs = 1, combineURLs = function(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
  }), combineURLs;
}
var buildFullPath, hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var isAbsoluteURL2 = requireIsAbsoluteURL(), combineURLs2 = requireCombineURLs();
  return buildFullPath = function(baseURL, requestedURL) {
    return baseURL && !isAbsoluteURL2(requestedURL) ? combineURLs2(baseURL, requestedURL) : requestedURL;
  }, buildFullPath;
}
var parseHeaders, hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var utils2 = utils$9, ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return parseHeaders = function(headers) {
    var parsed = {}, key, val, i;
    return headers && utils2.forEach(headers.split(`
`), function(line) {
      if (i = line.indexOf(":"), key = utils2.trim(line.substr(0, i)).toLowerCase(), val = utils2.trim(line.substr(i + 1)), key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0)
          return;
        key === "set-cookie" ? parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]) : parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }), parsed;
  }, parseHeaders;
}
var isURLSameOrigin, hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var utils2 = utils$9;
  return isURLSameOrigin = utils2.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var msie = /(msie|trident)/i.test(navigator.userAgent), urlParsingNode = document.createElement("a"), originURL;
      function resolveURL(url) {
        var href = url;
        return msie && (urlParsingNode.setAttribute("href", href), href = urlParsingNode.href), urlParsingNode.setAttribute("href", href), {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      return originURL = resolveURL(window.location.href), function(requestURL) {
        var parsed = utils2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin;
}
var xhr, hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var utils2 = utils$9, settle2 = requireSettle(), cookies2 = requireCookies(), buildURL3 = buildURL$1, buildFullPath2 = requireBuildFullPath(), parseHeaders2 = requireParseHeaders(), isURLSameOrigin2 = requireIsURLSameOrigin(), createError2 = requireCreateError();
  return xhr = function(config) {
    return new Promise(function(resolve, reject) {
      var requestData = config.data, requestHeaders = config.headers, responseType = config.responseType;
      utils2.isFormData(requestData) && delete requestHeaders["Content-Type"];
      var request2 = new XMLHttpRequest();
      if (config.auth) {
        var username = config.auth.username || "", password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
        requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
      }
      var fullPath = buildFullPath2(config.baseURL, config.url);
      request2.open(config.method.toUpperCase(), buildURL3(fullPath, config.params, config.paramsSerializer), !0), request2.timeout = config.timeout;
      function onloadend() {
        if (request2) {
          var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders2(request2.getAllResponseHeaders()) : null, responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response, response = {
            data: responseData,
            status: request2.status,
            statusText: request2.statusText,
            headers: responseHeaders,
            config,
            request: request2
          };
          settle2(resolve, reject, response), request2 = null;
        }
      }
      if ("onloadend" in request2 ? request2.onloadend = onloadend : request2.onreadystatechange = function() {
        !request2 || request2.readyState !== 4 || request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0) || setTimeout(onloadend);
      }, request2.onabort = function() {
        request2 && (reject(createError2("Request aborted", config, "ECONNABORTED", request2)), request2 = null);
      }, request2.onerror = function() {
        reject(createError2("Network Error", config, null, request2)), request2 = null;
      }, request2.ontimeout = function() {
        var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
        config.timeoutErrorMessage && (timeoutErrorMessage = config.timeoutErrorMessage), reject(createError2(
          timeoutErrorMessage,
          config,
          config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          request2
        )), request2 = null;
      }, utils2.isStandardBrowserEnv()) {
        var xsrfValue = (config.withCredentials || isURLSameOrigin2(fullPath)) && config.xsrfCookieName ? cookies2.read(config.xsrfCookieName) : void 0;
        xsrfValue && (requestHeaders[config.xsrfHeaderName] = xsrfValue);
      }
      "setRequestHeader" in request2 && utils2.forEach(requestHeaders, function(val, key) {
        typeof requestData > "u" && key.toLowerCase() === "content-type" ? delete requestHeaders[key] : request2.setRequestHeader(key, val);
      }), utils2.isUndefined(config.withCredentials) || (request2.withCredentials = !!config.withCredentials), responseType && responseType !== "json" && (request2.responseType = config.responseType), typeof config.onDownloadProgress == "function" && request2.addEventListener("progress", config.onDownloadProgress), typeof config.onUploadProgress == "function" && request2.upload && request2.upload.addEventListener("progress", config.onUploadProgress), config.cancelToken && config.cancelToken.promise.then(function(cancel) {
        request2 && (request2.abort(), reject(cancel), request2 = null);
      }), requestData || (requestData = null), request2.send(requestData);
    });
  }, xhr;
}
var utils$5 = utils$9, normalizeHeaderName2 = normalizeHeaderName$1, enhanceError2 = enhanceError$1, DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  !utils$5.isUndefined(headers) && utils$5.isUndefined(headers["Content-Type"]) && (headers["Content-Type"] = value);
}
function getDefaultAdapter() {
  var adapter;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (adapter = requireXhr()), adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue))
    try {
      return (parser || JSON.parse)(rawValue), utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError")
        throw e;
    }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function(data, headers) {
    return normalizeHeaderName2(headers, "Accept"), normalizeHeaderName2(headers, "Content-Type"), utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data) ? data : utils$5.isArrayBufferView(data) ? data.buffer : utils$5.isURLSearchParams(data) ? (setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8"), data.toString()) : utils$5.isObject(data) || headers && headers["Content-Type"] === "application/json" ? (setContentTypeIfUnset(headers, "application/json"), stringifySafely(data)) : data;
  }],
  transformResponse: [function(data) {
    var transitional2 = this.transitional, silentJSONParsing = transitional2 && transitional2.silentJSONParsing, forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing, strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length)
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing)
          throw e.name === "SyntaxError" ? enhanceError2(e, this, "E_JSON_PARSE") : e;
      }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(status) {
    return status >= 200 && status < 300;
  }
};
defaults$3.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
utils$5.forEach(["delete", "get", "head"], function(method) {
  defaults$3.headers[method] = {};
});
utils$5.forEach(["post", "put", "patch"], function(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3, utils$4 = utils$9, defaults$2 = defaults_1, transformData$1 = function(data, headers, fns) {
  var context = this || defaults$2;
  return utils$4.forEach(fns, function(fn) {
    data = fn.call(context, data, headers);
  }), data;
}, isCancel$1, hasRequiredIsCancel;
function requireIsCancel() {
  return hasRequiredIsCancel || (hasRequiredIsCancel = 1, isCancel$1 = function(value) {
    return !!(value && value.__CANCEL__);
  }), isCancel$1;
}
var utils$3 = utils$9, transformData2 = transformData$1, isCancel = requireIsCancel(), defaults$1 = defaults_1;
function throwIfCancellationRequested(config) {
  config.cancelToken && config.cancelToken.throwIfRequested();
}
var dispatchRequest$1 = function(config) {
  throwIfCancellationRequested(config), config.headers = config.headers || {}, config.data = transformData2.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  ), config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  ), utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(method) {
      delete config.headers[method];
    }
  );
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function(response) {
    return throwIfCancellationRequested(config), response.data = transformData2.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    ), response;
  }, function(reason) {
    return isCancel(reason) || (throwIfCancellationRequested(config), reason && reason.response && (reason.response.data = transformData2.call(
      config,
      reason.response.data,
      reason.response.headers,
      config.transformResponse
    ))), Promise.reject(reason);
  });
}, utils$2 = utils$9, mergeConfig$2 = function(config1, config2) {
  config2 = config2 || {};
  var config = {}, valueFromConfig2Keys = ["url", "method", "data"], mergeDeepPropertiesKeys = ["headers", "auth", "proxy", "params"], defaultToConfig2Keys = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], directMergeKeys = ["validateStatus"];
  function getMergedValue(target, source) {
    return utils$2.isPlainObject(target) && utils$2.isPlainObject(source) ? utils$2.merge(target, source) : utils$2.isPlainObject(source) ? utils$2.merge({}, source) : utils$2.isArray(source) ? source.slice() : source;
  }
  function mergeDeepProperties(prop) {
    utils$2.isUndefined(config2[prop]) ? utils$2.isUndefined(config1[prop]) || (config[prop] = getMergedValue(void 0, config1[prop])) : config[prop] = getMergedValue(config1[prop], config2[prop]);
  }
  utils$2.forEach(valueFromConfig2Keys, function(prop) {
    utils$2.isUndefined(config2[prop]) || (config[prop] = getMergedValue(void 0, config2[prop]));
  }), utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties), utils$2.forEach(defaultToConfig2Keys, function(prop) {
    utils$2.isUndefined(config2[prop]) ? utils$2.isUndefined(config1[prop]) || (config[prop] = getMergedValue(void 0, config1[prop])) : config[prop] = getMergedValue(void 0, config2[prop]);
  }), utils$2.forEach(directMergeKeys, function(prop) {
    prop in config2 ? config[prop] = getMergedValue(config1[prop], config2[prop]) : prop in config1 && (config[prop] = getMergedValue(void 0, config1[prop]));
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys), otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  return utils$2.forEach(otherKeys, mergeDeepProperties), config;
};
const name = "axios", version = "0.21.4", description = "Promise based HTTP client for the browser and node.js", main = "index.js", scripts = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, repository = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, keywords = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], author = "Matt Zabriskie", license = "MIT", bugs = {
  url: "https://github.com/axios/axios/issues"
}, homepage = "https://axios-http.com", devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, browser = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, jsdelivr = "dist/axios.min.js", unpkg = "dist/axios.min.js", typings = "./index.d.ts", dependencies = {
  "follow-redirects": "^1.14.0"
}, bundlesize = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], require$$0 = {
  name,
  version,
  description,
  main,
  scripts,
  repository,
  keywords,
  author,
  license,
  bugs,
  homepage,
  devDependencies,
  browser,
  jsdelivr,
  unpkg,
  typings,
  dependencies,
  bundlesize
};
var pkg = require$$0, validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
  validators$1[type] = function(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {}, currentVerArr = pkg.version.split(".");
function isOlderVersion(version2, thanVersion) {
  for (var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr, destVer = version2.split("."), i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i])
      return !0;
    if (pkgVersionArr[i] < destVer[i])
      return !1;
  }
  return !1;
}
validators$1.transitional = function(validator2, version2, message) {
  var isDeprecated = version2 && isOlderVersion(version2);
  function formatMessage(opt, desc) {
    return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === !1)
      throw new Error(formatMessage(opt, " has been removed in " + version2));
    return isDeprecated && !deprecatedWarnings[opt] && (deprecatedWarnings[opt] = !0, console.warn(
      formatMessage(
        opt,
        " has been deprecated since v" + version2 + " and will be removed in the near future"
      )
    )), validator2 ? validator2(value, opt, opts) : !0;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options != "object")
    throw new TypeError("options must be an object");
  for (var keys = Object.keys(options), i = keys.length; i-- > 0; ) {
    var opt = keys[i], validator2 = schema[opt];
    if (validator2) {
      var value = options[opt], result = value === void 0 || validator2(value, opt, options);
      if (result !== !0)
        throw new TypeError("option " + opt + " must be " + result);
      continue;
    }
    if (allowUnknown !== !0)
      throw Error("Unknown option " + opt);
  }
}
var validator$1 = {
  isOlderVersion,
  assertOptions,
  validators: validators$1
}, utils$1 = utils$9, buildURL2 = buildURL$1, InterceptorManager = InterceptorManager_1, dispatchRequest2 = dispatchRequest$1, mergeConfig$1 = mergeConfig$2, validator = validator$1, validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig, this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function(config) {
  typeof config == "string" ? (config = arguments[1] || {}, config.url = arguments[0]) : config = config || {}, config = mergeConfig$1(this.defaults, config), config.method ? config.method = config.method.toLowerCase() : this.defaults.method ? config.method = this.defaults.method.toLowerCase() : config.method = "get";
  var transitional2 = config.transitional;
  transitional2 !== void 0 && validator.assertOptions(transitional2, {
    silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
    forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
    clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
  }, !1);
  var requestInterceptorChain = [], synchronousRequestInterceptors = !0;
  this.interceptors.request.forEach(function(interceptor) {
    typeof interceptor.runWhen == "function" && interceptor.runWhen(config) === !1 || (synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous, requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected));
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    for (Array.prototype.unshift.apply(chain, requestInterceptorChain), chain = chain.concat(responseInterceptorChain), promise = Promise.resolve(config); chain.length; )
      promise = promise.then(chain.shift(), chain.shift());
    return promise;
  }
  for (var newConfig = config; requestInterceptorChain.length; ) {
    var onFulfilled = requestInterceptorChain.shift(), onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  for (; responseInterceptorChain.length; )
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  return promise;
};
Axios$1.prototype.getUri = function(config) {
  return config = mergeConfig$1(this.defaults, config), buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function(method) {
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data
    }));
  };
});
var Axios_1 = Axios$1, Cancel_1, hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function Cancel(message) {
    this.message = message;
  }
  return Cancel.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, Cancel.prototype.__CANCEL__ = !0, Cancel_1 = Cancel, Cancel_1;
}
var CancelToken_1, hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var Cancel = requireCancel();
  function CancelToken(executor) {
    if (typeof executor != "function")
      throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function(resolve) {
      resolvePromise = resolve;
    });
    var token = this;
    executor(function(message) {
      token.reason || (token.reason = new Cancel(message), resolvePromise(token.reason));
    });
  }
  return CancelToken.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, CancelToken.source = function() {
    var cancel, token = new CancelToken(function(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }, CancelToken_1 = CancelToken, CancelToken_1;
}
var spread, hasRequiredSpread;
function requireSpread() {
  return hasRequiredSpread || (hasRequiredSpread = 1, spread = function(callback) {
    return function(arr) {
      return callback.apply(null, arr);
    };
  }), spread;
}
var isAxiosError, hasRequiredIsAxiosError;
function requireIsAxiosError() {
  return hasRequiredIsAxiosError || (hasRequiredIsAxiosError = 1, isAxiosError = function(payload) {
    return typeof payload == "object" && payload.isAxiosError === !0;
  }), isAxiosError;
}
var utils = utils$9, bind2 = bind$2, Axios = Axios_1, mergeConfig2 = mergeConfig$2, defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig), instance = bind2(Axios.prototype.request, context);
  return utils.extend(instance, Axios.prototype, context), utils.extend(instance, context), instance;
}
var axios = createInstance(defaults);
axios.Axios = Axios;
axios.create = function(instanceConfig) {
  return createInstance(mergeConfig2(axios.defaults, instanceConfig));
};
axios.Cancel = requireCancel();
axios.CancelToken = requireCancelToken();
axios.isCancel = requireIsCancel();
axios.all = function(promises) {
  return Promise.all(promises);
};
axios.spread = requireSpread();
axios.isAxiosError = requireIsAxiosError();
axios$1.exports = axios;
axios$1.exports.default = axios;
var axiosExports = axios$1.exports;
export {
  EventProperties as E,
  PAGEVIEW as P,
  _Stack as _,
  isArguments_1 as a,
  bytesToUuid_1 as b,
  isBufferExports as c,
  isTypedArray_1 as d,
  isFunction_1 as e,
  isLength_1 as f,
  _equalArrays as g,
  _equalByTag as h,
  isArray_1 as i,
  _getTag as j,
  isObjectLike_1 as k,
  isObject_1 as l,
  isSymbol_1 as m,
  _baseToString as n,
  _stringToPath as o,
  _defineProperty as p,
  eq_1 as q,
  rngBrowserExports as r,
  _arrayMap as s,
  axiosExports as t,
  _baseGetTag as u,
  isArray$3 as v,
  browserCookies as w
};
//# sourceMappingURL=axios-5f69b112.js.map
